// ==============================|| MENU ITEMS - BANNER ROUTES ||============================== //

// icons
import DoneAllIcon from '@mui/icons-material/DoneAll';

const TipsRoutes = {
  id: 'Tips-group',
  title: 'Tips Management',
  type: 'group',
  children: [
    {
      id: 'Tips-list',
      title: 'Tips List',
      type: 'item',
      url: '/tips/list',
      icon: DoneAllIcon,
      target: false
    }
  ]
};

export default TipsRoutes;
